export default class OwnerSearchResult {
    id: number;
    number: number;
    name: string;
    spouseName: string;
    type: string;
    containerOwnerId: number;
    selected: boolean;
    isClientAcreage: boolean;
}



// WEBPACK FOOTER //
// ./src/models/OwnerSearchResult.ts